// client/src/components/Footer.jsx
import React from 'react';
import { NavLink, useInRouterContext } from 'react-router-dom';

function FooterLink({ to, children }) {
  const inRouter = useInRouterContext();
  const base =
    'hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80 focus-visible:ring-offset-2 focus-visible:ring-offset-[#000099] rounded-sm';

  // Fallback til <a> hvis Footer rendres utenfor <BrowserRouter>
  if (!inRouter) {
    return (
      <a href={to} className={base}>
        {children}
      </a>
    );
  }

  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        `${base} ${isActive ? 'underline underline-offset-4' : ''}`
      }
    >
      {children}
    </NavLink>
  );
}

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#000099] text-white py-4 mt-12" role="contentinfo">
      <div className="max-w-screen-xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm">
        <div>© {year} Ryfylke Utleie. Alle rettigheter reservert.</div>

        <nav aria-label="Bunnmeny">
          <ul className="flex items-center gap-4">
            <li>
              <FooterLink to="/terms">Leievilkår</FooterLink>
            </li>
            <li>
            <FooterLink to="/kjopsvilkar">Kjøpsvilkår</FooterLink>
            </li>
            <li>
              <FooterLink to="/privacy">Personvernerklæring</FooterLink>
            </li>
            <li>
              <FooterLink to="/contact">Kontakt oss</FooterLink>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
